<template>
  <div class="card _pb-6 _mb-8">
    <div class="card__title _fs-20 _lh-26 _tc-dark _mb-2">
      {{ material.title }}
    </div>
    <div class="d-md-flex align-center d-block">
      <div class="d-flex align-center _mb-sm-4 _mb-md-0">
        <AppBtn class="_mr-4" :btnClass="'btn_secondary'"
          ><div
            class="d-flex _py-2 _px-3"
            v-if="type === 'material'"
            @click="download()"
          >
            <svg
              class="_mr-2"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 13V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V13M5 8L10 13M10 13L15 8M10 13V1"
                stroke="#629727"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span class="_fs-16 _lh-24">{{
              $t('interface.additional_material_card.download')
            }}</span>
          </div>
          <div
            @click="goTo()"
            class="_py-2 _px-3 _fs-16 _lh-24 _tc-green-second"
            v-else
          >
            {{ $t('interface.additional_material_card.go') }}
          </div>
        </AppBtn>
        <div
          class="card__file-type"
          v-if="type === 'material' && material.file"
        >
          <span class="_fs-20 _lh-22 _tc-dark-grey _fw-500">{{
            material.file.match(/\.([^.]+)$|$/)[1].toUpperCase()
          }}</span>
          ・
          <span class="_fs-20 _lh-22 _tc-dark-grey">{{
            getWeightFile(material.file_size)
          }}</span>
        </div>
      </div>
      <CardFavorite
        v-if="type === 'material'"
        :mobileColumn="true"
        @like="like"
        @favorite="favorite"
        :like="material.like"
        :favorite="material.favorite"
        :likesCount="material.likes_count"
        class="_ml-auto d-md-flex _mb-lg-0 _mb-md-0 _mb-0 _mb-sm-0 _mb-xs-0 _px-lg-0 _px-md-0 _px-0 _px-sm-0 _px-xs-0"
      />
      <CardFavorite
        v-else
        :mobileColumn="true"
        @like="like"
        @favorite="favorite"
        :like="material.like"
        :favorite="material.favorite"
        :likesCount="material.likes_count"
        class="_ml-auto d-md-flex _mb-lg-0 _mb-md-0 _mb-0 _mb-sm-0 _mb-xs-0 _px-lg-0 _px-md-0 _px-0 _px-sm-0 _px-xs-0"
      />
    </div>
  </div>
</template>

<script>
import AppBtn from '../buttons/AppBtn.vue'
import CardFavorite from './CardFavorite.vue'
import download from '@/mixins/download'
import fileSize from '@/mixins/fileSize'
import { mapActions } from 'vuex'
export default {
  name: 'AdditionalMaterialCard',
  props: {
    type: {
      type: String,
      default: 'material',
    },
    material: Object,
    analyticEventPrefix: String,
  },
  data: () => ({}),
  mixins: [download, fileSize],
  components: { AppBtn, CardFavorite },
  methods: {
    ...mapActions(['']),
    async like() {
      this.$emit('like', this.material.id)
      if (!this.material.like) {
        if (this.$gtm && this.analyticEventPrefix) {
          this.$gtm.push({
            event: this.analyticEventPrefix + 'like',
            param_value: this.helpers.stripHtml(this.material.title),
          })
        }
      }
    },
    async favorite() {
      this.$emit('favorite', this.material.id)
      if (!this.material.favorite) {
        if (this.$gtm && this.analyticEventPrefix) {
          this.$gtm.push({
            event: this.analyticEventPrefix + 'to_favorite',
            param_value: this.helpers.stripHtml(this.material.title),
          })
        }
      }
    },
    async goTo() {
      window.open(this.material.link)
      if (this.$gtm && this.analyticEventPrefix) {
        this.$gtm.push({
          event: this.analyticEventPrefix + 'link',
          param_value: this.helpers.stripHtml(this.material.title),
        })
      }
    },
    async download() {
      this.downloadFile(
        this.material.file || this.material.link,
        this.material.title
      )
      if (this.$gtm && this.analyticEventPrefix) {
        this.$gtm.push({
          event: this.analyticEventPrefix + 'download',
          param_value: this.helpers.stripHtml(this.material.title),
        })
      }
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.card {
  border-bottom: 1px solid #b2b4b2;

  &:last-child {
    margin-bottom: 0 !important;
    border: 0;
  }
}
</style>
